import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  body {
    /* Cores do sistema de design VeloPrime */
    --veloprime-deep-navy: #0F1A2E;
    --veloprime-soft-gold: #B8860B;
    --veloprime-text-primary: #F8F8F8;
    --veloprime-text-secondary: #36454F;
    --veloprime-bg-primary: #0F1A2E;
    --veloprime-bg-dark: #1A2A4D;
    --veloprime-bg-alternative: #F8F8F8;
    
    /* Cores do sistema de design Velotax/Velopro (mantidas para compatibilidade) */
    --velotax-blue-1: #000058;
    --velotax-blue-2: #1634ff;
    --velotax-font-color: #272A30;
    --velotax-background-color: #ffffff;
    --light-gray: #ECF0F6;
    --ant-primary-color: #B8860B;;
    --ant-success-color: #00cc8b;
    --ant-error-color: #DD2244;
    --ant-warning-color: #FBC105;
    
    /* Cores existentes mantidas para compatibilidade */
    --red: #DD2244;
    --green: #00cc8b;
    --yellow: #FBC105;
    --white: #ffffff;
    --black: #000000;
    --ghost: #E8E8E8;
    --ghost-white: #F0F4F8;
    --gray-1: #ABAAA8;
    --gray-2: #808080;
    --gray-3: #3D3D3D;
    --dark-1: #242424;
    --dark-2: #1f1f1f;
    --dark-3: #181818;
    --velotax-blue-2-checked: #1634ff15;
    --velotax-ghost: #f4f6f8;
    --velotax-ghost-white: #f4f6f8;
    --velotax-disabled: #626368;
    --velotax-font-color-ghost: #99aabb;
    --velotax-background-color-ghost: #eaecee;
    --velotax-shadow-primary: rgba(0, 0, 88, 0.24);
    --velotax-shadow-default: rgba(144, 153, 170, 0.16);
    --velotax-orange: #ff8400;
  }

  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  *:focus {
    outline: 0;
  }

  html, body, #root {
    height: 100%;
    overflow: hidden;
    color: var(--veloprime-text-primary);
  }

  body {
    -webkit-font-smoothing: antialiased;
    position: relative;
    width: 100% !important;
    background: var(--veloprime-bg-primary);
  }

  body, input, button {
    font: 14px 'Nunito Sans', sans-serif;
  }

  a {
    text-decoration: none;
  }

  ul {
    list-style: none;
  }

  button {
    cursor: pointer;
    background: transparent;
    border: 0;
    outline: 0;
    color: var(--veloprime-text-primary);
    letter-spacing: 0.4px;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: var(--veloprime-text-primary);
    font-family: 'Nunito Sans', sans-serif;
    font-weight: bold;
  }

  body > iframe {
    display: none;
  }

  .full-width {
    width: 100%;
  }

  .column-center {
    text-align: center;
  }

  .beauty-scrollbar.zero-scrollbar {
    &::-webkit-scrollbar,
    ::-webkit-scrollbar {
      width: 0;
    }
  }

  .beauty-scrollbar.slim-scrollbar {
    &::-webkit-scrollbar,
    ::-webkit-scrollbar {
      width: 4px;
    }
  }

  .ant-modal-wrap,
  .beauty-scrollbar {
    &::-webkit-scrollbar,
    ::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-thumb,
    ::-webkit-scrollbar-thumb {
      border-radius: 0;
      background-color: var(--ant-primary-color);
    }

    &::-webkit-scrollbar-track,
    ::-webkit-scrollbar-track {
      background-color: var(--velotax-background-color-ghost);
    }
  }

  .input {

    .label {
      margin-bottom: 6px;
    }

    & + div {
      margin-top: 12px;
    }
  }

  .ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .error {
    margin: 12px auto -12px auto;
    color: var(--ant-error-color);
  }

  .success {
    color: #4DCD66;
  }

  .loading-session {
    background: var(--ant-info-color);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 12;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 250px;
      padding: 20px;
    }

    .anticon {
      color: var(--white);

      svg {

        height: 40px;
        width: 40px;
      }
    }
  }

  .hiring-modal {
    .ant-typography {
      color: var(--velotax-font-color);
    }
    .ant-modal-title::before {
      display: none;
    }
    .hiring-modal-title {
      font-size: 32px;
      font-weight: bold;
      margin: 32px auto;
      text-align: center;
      color: var(--ant-primary-color);
    }
  }

  .ant-modal .malha-fina-button {
    width: 100% !important;
  }

  ::placeholder {
    color: var(--velotax-font-color-ghost) !important;
  }
  .ant-select-selection-placeholder {
    font-size: 16px !important;
    font-weight: 500 !important;
    color: var(--velotax-font-color-ghost) !important;
  }
  .ant-upload {
    color: var(--ant-primary-color);
    background-color: transparent !important;
    /* border-color: var(--yellow) !important; */
  }

  .ant-btn-text:focus,
  .ant-btn-text:hover {
    color: var(--velotax-font-color-ghost);
  }
  .ant-layout-sider-light,
  .ant-menu {
    background-color: var(--velotax-blue-1);
  }

  .ant-table-filter-dropdown {
    min-width: 150px;
  }

  .ant-table-filter-dropdown-btns {
    .ant-btn-sm {
      width: 50%
    }
  }

  .ant-card {
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    cursor: pointer;
  }
  .ant-card.lembretes {
    height: 150px;
  }

   @media screen and (max-width: 575px) {
      .ant-card {
        height: auto;
      }
  }

  /* .anticon, */
  .ant-btn-text,
  .ant-checkbox + span,
  .ant-divider-inner-text,
  /* .ant-dropdown-menu, */
  /* .ant-dropdown-menu-item, */
  .ant-empty,
  .ant-form,
  .ant-form-item-label > label,
  .ant-input-number-input,
  .ant-list,
  .ant-list-item,
  .ant-radio-wrapper,
  .ant-select,
  /* .ant-select-dropdown,
  .ant-select-item, */
  .ant-upload-list-item-name,
  .ant-typography {
    color: var(--veloprime-deep-navy);
  }
  .ant-input[disabled],
  .ant-select-disabled .ant-select-selector {
    color: var(--velotax-disabled) !important;
    background-color: var(--ghost);
  }
  /* .ant-select-item:hover,
  .ant-dropdown-menu-item:hover,
  .ant-select-item-option-active {
  }*/
  .ant-select-item-option-selected {
    color: var(--black) !important;
    background-color: var(--gray-1) !important;
    border: none;
  }
  .ant-modal-footer,
  .ant-divider {
    border-color: var(--velotax-ghost-white);
  }
  .ant-btn.ant-btn-icon-only.ant-btn-primary {
    svg {
      fill: var(--ant-primary-color);
    }
  }
  .ant-btn.ant-btn-icon-only {
    svg {
      fill: var(--ant-primary-color);
    }
  }

  .success-icon {
    svg {
      fill: var(--ant-success-color) !important;
    }
  }
  .error-icon {
    svg {
      fill: var(--ant-error-color) !important;
    }
  }

  .footer-secure {
    position: fixed;
    background: var(--white);
    height: 56px;
    bottom: 24px;
    right: 104px;
    z-index: 10;
    display: flex;
    justify-content: flex-end;
    padding: 0 10px;
    max-height: 64px;
    border-radius: 6px;
    box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.1);

    &.goleft {
      left: 32px;
      right: auto;
    }

    img {
      width: 70px;
    }
  }

  .footer-velotax {
    left: 0;
    right: auto;
    row-gap: 5px;
    display: flex;
    box-shadow: none;
    align-items: center;
    flex-direction: column;
    background-color: transparent;
    transform: scale(0.75) translateY(16px);
    opacity: 0.625;
    color: var(--velotax-font-color);
    :hover {
      color: var(--velotax-font-color);
      i {
        opacity: 0.8;
      }
    }

    img {
      width: 128px;
    }

    i {
      font-size: 12px;
      font-weight: 600;
    }
  }

  .poweredby-velotax {
    height: 64px;
    padding: 6px 10px;
    max-height: 64px;
    row-gap: 5px;
    display: flex;
    align-items: center;
    flex-direction: column;
    color: var(--velotax-font-color);
    :hover {
      color: var(--velotax-font-color);
      i {
        opacity: 0.8;
      }
    }
    
    &.sidebar {
      border-top: 1px solid var(--dark-1);
      img {
        height: 20px;
      }
      i {
        font-size: 12px;
        font-weight: 600;
      }
    }
  }

  /**
  * ANT-RADIO
  */
  .ant-radio-group {
    display: flex;
    row-gap: 8px;
    flex-direction: column;

    .ant-radio-wrapper {
      font-size: 18px;

      .ant-radio {
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }

      .ant-radio-inner {
        width: 22px;
        height: 22px;
        border-width: 2px;

        &:after {
          top: 2px;
          left: 2px;
          width: 14px;
          height: 14px;
          border-radius: 8px;
        }
      }
    }
  }

  /**
  * ANT-INPUT
  */
  .ant-input {
    font-weight: 500;
    border-radius: 4px;
    border: 2px solid var(--light-gray);
    background-color: var(--light-gray);

    &:hover, &:focus {
      border-right-width: 2px !important;
    }

    &:focus {
      box-shadow: none;
      /* box-shadow: 0 0 0 4px var(--ant-primary-color-outline); */
    }

    &[disabled] {
      cursor: default;
      /* background-color: var(--ghost);
      border-color: var(--ghost); */
    }

    &.ant-input-lg {
      height: 56px;
    }
  }

  .ant-form-item-has-error {
    .ant-input:not(.ant-input-disabled):not(.ant-input-borderless) {
      background-color: var(--light-gray) !important;
      border-color: var(--ant-error-color) !important;
    }

    .ant-input:not(.ant-input-disabled):not(.ant-input-borderless):focus {
      border-right-width: 2px !important;
      box-shadow: none;
      /* box-shadow: 0 0 0 4px var(--ant-error-color-outline) !important; */
    }
  }

  .ant-input-affix-wrapper {
    padding: 0;
    height: 48px;
    border-radius: 4px;
    border: 2px solid var(--light-gray);
    background-color: var(--light-gray);

    :not(.ant-input-affix-wrapper-disabled):hover,
    :not(.ant-input-affix-wrapper-disabled).ant-input-affix-wrapper-focused {
      /* border: 2px solid var(--ant-primary-color); */
      border-right-width: 2px !important;
    }

    :not(.ant-input-affix-wrapper-disabled).ant-input-affix-wrapper-focused {
      box-shadow: none;
      /* box-shadow: 0 0 0 4px var(--ant-primary-color-outline); */

      .ant-input-prefix {
        svg {
          fill: var(--ant-primary-color);
        }
      }
    }

    .ant-input-prefix {
      padding: 0 8px 0 12px;

      svg {
        fill: var(--velotax-font-color-ghost);
      }
    }

    .ant-input {
      height: 44px;
      font-weight: 300;
      color: #000000;
      border: 1px solid var(--light-gray);
      background-color: var(--light-gray);
    }
  }

  /**
  * ANT-INPUT-NUMBER
  */
  .ant-input-number {
    font-weight: 500;
    border-radius: 4px;
    border: 2px solid var(--light-gray);
    background-color: var(--light-gray);
    display: flex;
    align-items: center;

    &:hover {
      border-right-width: 2px !important;
    }

    &.ant-input-number-focused {
      border-right-width: 2px !important;
      border-color: var(--ant-primary-color);
      box-shadow: 0 0 0 4px var(--ant-primary-color-outline);
    }

    &.ant-input-number-lg {
      height: 48px;
    }

    &.ant-input-number-disabled,
    &.ant-input-number-disabled .ant-input-number-input {
      cursor: default;
    }

    .ant-input-number-handler-wrap {
      display: none;
    }

    .ant-input-number-input-wrap {
      .ant-input-number-input {
        font-size: 18px;
        font-weight: 500;
      }
    }
  }

  .ant-form-item-has-error {
    .ant-input-number:not([disabled]):hover,
    .ant-input-number-focused:not([disabled]) {
      border-right-width: 2px !important;
      border-color: var(--ant-error-color);
    }
  }

  /**
  * ANT-SELECT
  */
  .ant-select-focused .ant-select-selector {
    box-shadow: none !important;
    border: none !important;
  }
  .ant-select-arrow {
    color: black;
  }

  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    width: 100%;
    height: 40px;
}

  .ant-select .ant-select-selector {
    border-radius: 4px !important;
    border: 1px solid var(--light-gray) !important;
    background-color: var(--light-gray) !important;
    .ant-select-selection-search, .ant-select-selection-item {
      display: flex;
      align-items: center;
      font-weight: 600 !important;
      font-size: 15px;
    }
  }
  /* .ant-select {
    border-radius: 8px !important;

    &[disabled],
    &.ant-select-disabled,
    &.ant-select-disabled input,
    &.ant-select-disabled .ant-select-selector {
      cursor: default !important;
    }
  }

  .ant-select .ant-select-selector {
    border-radius: 8px !important;
    border: 2px solid var(--dark-1) !important;
    background-color: var(--dark-1) !important;
    .ant-select-selection-search, .ant-select-selection-item {
      display: flex;
      align-items: center;
      font-weight: 500 !important;
    }
  }

  .ant-select-focused.ant-select-open {
    box-shadow: none !important;

    .ant-select-selector {
      border-color: var(--ant-primary-color) !important;
    }
  }

  .ant-select:not(.ant-select-disabled):hover .ant-select-selector,
  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-right-width: 2px !important;
    box-shadow: 0 0 0 4px var(--ant-primary-color-outline) !important;
  }

  .ant-form-item-has-error {
    .ant-select:not(.ant-select-disabled):hover .ant-select-selector,
    .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
      border-right-width: 2px !important;
      box-shadow: 0 0 0 4px var(--ant-error-color-outline) !important;
    }
  }

  .ant-select-lg, .ant-select-lg .ant-select-selector {
    height: 48px !important;

    .ant-select-selection-placeholder {
      display: flex;
      align-items: center;
    }
  } */

  .ant-select-lg, .ant-select-lg .ant-select-selector {
    height: 56px !important;

    .ant-select-selection-placeholder {
      display: flex;
      font-size: 14px;
      align-items: center;
    }
  }

  .ant-select-lg.ant-select-multiple {
    min-height: 56px !important;
    .ant-select-selector {
      min-height: 56px !important;
      overflow-y: auto;
    }
  }
  .ant-select-multiple {
    max-height: 128px;
    height: auto !important;
    .ant-select-selector {
      max-height: 128px;
      height: auto !important;
    }
  }

  /**
  * ANT-DROPDOWN
  */
  .ant-dropdown,
  .ant-select-dropdown {
    /* border-radius: 2px; */
    border: none;

    z-index:1000;

    .ant-select-item,
    .ant-dropdown-menu-item {
      font-size: 16px
    }

    .ant-dropdown-menu {
      border-radius: 8px;
    }
  }

  /**
  * ANT-MODAL
  */
  .ant-modal-root {
    .ant-modal {
      top: 32px;

      .ant-modal-content {
        border-radius: 16px;
        background-color: var(--white);

        .description {
          background-color: rgba(10, 158, 90, 0.10);
          padding: 9px 15px;
          color: rgb(10, 158, 90);
        }

        .modal-row {
          margin-top: 10px;
        }
        .ant-upload.ant-upload-select-picture-card {
          border: 1px solid #d9d9d9;
        }
        .ant-modal-close {
          top: 16px;
          right: 16px;

          .ant-modal-close-x {
            .anticon.anticon-close.ant-modal-close-icon {
              color: var(--ant-primary-color);
              font-size: 20px;
            }
          }
        }

        .ant-modal-header {
          border-bottom: none;
          padding: 48px 96px 0 48px;
          border-radius: 16px 16px 0 0;
          background-color: var(--white);

          .ant-modal-title {
            font-size: 20px;
            line-height: 28px;
            font-weight: 600;
            padding-bottom: 16px;
            position: relative;

            &::before {
              content: '';
              bottom: 0;
              width: 80px;
              left: 0;
              height: 2px;
              position: absolute;
              background-color: var(--ant-primary-color);
            }
          }
        }

        .ant-modal-body {
          .icon-card {
            color: var(--ant-primary-color);
          }   
          padding: 32px 48px 48px;
        }
      }

      @media only screen and (max-device-width: 812px) {
        width: 100% !important;
        max-width: calc(100% - 32px);
        margin: 0 16px;
        padding-bottom: 54px;
      }
    }
  }

  .filter-modal {
    .corretoras-allcheck {
      display: flex;
      margin-bottom: 8px;
    }
    .month-select {
      width: 100%;
      height: auto !important;
      min-height: 56px;
        max-height: auto;
      .ant-select-selector {
        height: auto !important;
        min-height: 56px;
        max-height: auto;
      }
    }
    .ant-radio-group .ant-radio-wrapper {
      font-size: 14px;
      .ant-radio {
        margin-right: 0;
        padding-top: 1px;
        .ant-radio-inner {
          width: 20px;
          height: 20px;
          :after {
            top: 50%;
            left: 50%;
            width: 16px;
            height: 16px;
          }
        }
      }
    }
    .ant-checkbox-wrapper {
      align-items: center;
      .ant-checkbox {
        top: 0;
      }
      .ant-checkbox-checked {
        .ant-checkbox-inner {
          border-color: var(--ant-primary-color);
          background-color: var(--ant-primary-color);
        }
      }
      .ant-checkbox-inner {
        width: 20px;
        height: 20px;
        border-color: var(--light-gray);
        background-color: var(--light-gray);
        :after {
          width: 7px;
          height: 13px;
          top: calc(50% - 2px);
        }
      }
    }
  }


  /**
  * ANT-TABLE
  */
  .ant-table-wrapper {
    .ant-table-content,
    .ant-table-container {
      font-weight: 100;
      color: var(--gray-3);
      border-color: var(--dark-1);
    }

    .ant-checkbox-checked {
      .ant-checkbox-inner {
        border-color: var(--ant-primary-color);
        background-color: var(--ant-primary-color);
      }
    }
    .ant-checkbox-inner {
      border-color: var(--light-gray);
      background-color: var(--light-gray);
    }

    .ant-tag {
      align-items: center;
      display: inline-flex;
      justify-content: center;
      height: 24px;
      padding: 0 10px;
      font-weight: 500;
      border-radius: 12px;
      text-transform: uppercase;
    }

    .ant-table-thead > tr > th {
      font-size: 14px;
      font-weight: 300;
      color: var(--gray-2);
      background-color: var(--white);
      border-bottom: 1px solid var(--ghost);
    }

    table tr td.ant-table-selection-column,
    table tr th.ant-table-selection-column {
      padding-left: 16px;
    }

    .ant-table-tbody > tr > td {
      cursor: pointer;
      border-bottom: 1px solid var(--ghost);
    }
    .ant-table-row-selected > td {
      background-color: #f5f5f5 !important;
      border-bottom: 1px solid var(--dark-3);
    }
    .ant-table-row:hover > td,
    .ant-table-cell-row-hover {
      /* background-color: var(--dark-1) !important; */
    }

    .ant-pagination {
      .ant-icon {
        /* color: var(--black); */
      }
    }

    .ant-pagination-item {
      min-width: 28px;
    }

    .ant-pagination-next, .ant-pagination-prev {
      min-width: 28px;
    }

    .ant-pagination-item-link,
    .ant-pagination-disabled:hover .ant-pagination-item-link {
      /* border-color: var(--dark-1); */
    }

    .ant-pagination-item a {
      /* color: var(--black); */
    }

    .ant-pagination-item-active {
      /* border-color: var(--ant-primary-color); */
      a {
        /* color: var(--ant-primary-color); */
      }
    }

    .ant-pagination-item,
    .ant-pagination-item-link,
    .ant-pagination-item-active {
      /* background-color: var(--white); */
    }
    
    // Estilos responsivos para paginação em mobile
    @media only screen and (max-device-width: 812px) {
      .ant-pagination {
        display: flex !important;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;
        visibility: visible !important;
        opacity: 1 !important;
        position: relative !important;
        
        .ant-pagination-item,
        .ant-pagination-item-link {
          min-width: 32px;
          height: 32px;
          line-height: 30px;
          margin: 0 2px;
          display: inline-block !important;
          visibility: visible !important;
        }
        
        .ant-pagination-prev,
        .ant-pagination-next {
          margin: 0 4px;
          display: inline-block !important;
          visibility: visible !important;
        }
        
        .ant-pagination-item a {
          font-size: 14px;
          font-weight: 500;
          display: block !important;
          visibility: visible !important;
        }
        
        // Ocultar opções desnecessárias em mobile
        .ant-pagination-options {
          display: none;
        }
      }
      
      // Garantir que a paginação da tabela seja sempre visível
      .ant-table-pagination {
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
        position: relative !important;
        bottom: auto !important;
        margin: 16px 0 0 0 !important;
        padding: 16px !important;
        background-color: white !important;
        border-top: 1px solid #e8e8e8;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        z-index: 1000 !important;
      }
    }
    
    @media only screen and (max-device-width: 550px) {
      .ant-pagination {
        .ant-pagination-item,
        .ant-pagination-item-link {
          min-width: 28px;
          height: 28px;
          line-height: 26px;
          margin: 0 1px;
          display: inline-block !important;
          visibility: visible !important;
        }
        
        .ant-pagination-prev,
        .ant-pagination-next {
          margin: 0 2px;
          display: inline-block !important;
          visibility: visible !important;
        }
        
        .ant-pagination-item a {
          font-size: 12px;
          display: block !important;
          visibility: visible !important;
        }
      }
      
      // Garantir que a paginação da tabela seja sempre visível em telas muito pequenas
      .ant-table-pagination {
        padding: 12px !important;
        
        .ant-pagination-item,
        .ant-pagination-item-link {
          min-width: 28px;
          height: 28px;
          line-height: 26px;
          margin: 0 2px;
        }
        
        .ant-pagination-prev,
        .ant-pagination-next {
          margin: 0 4px;
        }
        
        .ant-pagination-item a {
          font-size: 12px;
        }
        
        .ant-pagination-options {
          display: none;
        }
      }
    }
  }
  /* .ant-table-title + .ant-table-container {
    border-radius: 12px;
  }
  .ant-table,
  .ant-table-title,
  .ant-table-footer {
    color: var(--velotax-font-color);
    background-color: var(--velotax-background-color);
  }
  .ant-table-tbody > tr.ant-table-row:hover > td,
  .ant-table-tbody > tr > td.ant-table-cell-row-hover,
  .ant-table-tbody > tr.ant-table-placeholder:hover > td {
    background-color: var(--velotax-background-color-ghost);
  }

  .ant-table-title {
    font-weight: 600;
    padding: 16px 0;
  }

  .ant-table-container {
    border-radius: 12px;
    border: 1px solid var(--velotax-ghost-white);
    background-color: var(--velotax-background-color);

    .ant-table-content {
      border-radius: 8px;

      overflow-x: auto;
      @media only screen and (min-device-width: 813px) {
        &::-webkit-scrollbar,
        ::-webkit-scrollbar {
          height: 4px;
        }

        &::-webkit-scrollbar-thumb,
        ::-webkit-scrollbar-thumb {
          border-radius: 0;
          background-color: var(--ant-primary-color);
        }

        &::-webkit-scrollbar-track,
        ::-webkit-scrollbar-track {
          background-color: var(--velotax-background-color-ghost);
        }
      }

      .ant-table-thead {
        .ant-table-cell {
          color: var(--velotax-font-color);
          border-bottom-color: var(--velotax-ghost-white);
          background-color: var(--dark-1);
          &::before {
            display: none;
          }

          &:first-child {
            border-radius: 12px 0 0 0;
          }

          &:last-child {
            border-radius: 0 12px 0 0;
          }
        }
      }

      .ant-table-tbody {
        .ant-table-cell {
          border-bottom-color: var(--velotax-ghost-white);
        }
        .ant-table-row:last-child {
          .ant-table-cell {
            border-bottom: none;

            &:first-child {
              border-radius: 0 0 0 12px;
            }

            &:last-child {
              border-radius: 0 0 12px 0;
            }
          }
        }
      }

      .ant-table-placeholder {
        .ant-table-cell {
          border-bottom: none;
        }
      }
    }

    .ant-table-row-error {
      .ant-table-cell {
        border-top: 1px solid;
        border-bottom: 1px solid !important;
        border-color: var(--ant-error-color) !important;

        &:first-of-type {
          border-left: 1px solid;
        }

        &:last-child {
          border-right: 1px solid;
        }
      }

      svg.error-icon {
        display: block;
        margin: 0 auto;
        fill: var(--ant-error-color);
      }
    }

    .ant-table-row-error + .ant-table-row-error {
      .ant-table-cell {
        border-top: none;
      }
    }
  } */

  body.dark {
    .ant-table-container {
      .ant-table-content {
        .ant-table-thead {
          .ant-table-cell {
            background-color: var(--velotax-background-color-ghost);
          }
        }
      }
    }
  }

  /**
  * ANT-DESCRIPTIONS
  */
  .ant-descriptions.ant-descriptions-bordered {
    .ant-descriptions-view {
      border-radius: 8px;
      border-color: var(--velotax-background-color-ghost);

      tbody {
        .ant-descriptions-row {
          border-color: var(--velotax-background-color-ghost);
          .ant-descriptions-item-label {
            color: var(--velotax-font-color);
            background-color: var(--light-gray);
            border-color: var(--velotax-background-color-ghost);
          }
          .ant-descriptions-item-content {
            background-color: var(--velotax-background-color);
            color: var(--velotax-font-color) !important;
          }
        }
      }
    }
  }

  /**
  * ANT-COLLAPSE
  */
  .ant-collapse,
  .ant-collapse.ant-collapse-borderless {
    background-color: transparent;
    /* background-color: var(--white); verificar */
    .ant-collapse-item {
      border-bottom: none;
      .ant-collapse-header {
        color: var(--velotax-font-color);
      }
    }
  }

  /**
  * ANT-LIST
  */
  .ant-list {
    &.ant-list-vertical {
      .ant-list-item {
        .ant-list-item-extra {
          text-align: right;
        }
      }
    }
  }
  .ant-list.ant-list-split {
    .ant-list-item {
      border-bottom-color: var(--velotax-background-color-ghost);
    }
  }
  .ant-list-empty-text {
    opacity: 0.75;
    color: var(--velotax-font-color);
  }

  .ant-list-loading {
    .ant-spin-blur:after {
      opacity: 0;
    }
  }

  /**
  * ANT-STEPS
  */
  .ant-steps {
    .ant-steps-item {
      &.ant-steps-item-active .ant-steps-item-title {
        color: var(--ant-primary-color) !important;
      }
      &.ant-steps-item-disabled .ant-steps-item-title {
        color: var(--velotax-font-color-ghost) !important;
      }
      .ant-steps-item-title {
        color: var(--velotax-font-color) !important;
      }
    }
    .ant-steps-item-process
        > .ant-steps-item-container
        > .ant-steps-item-tail::after,
      .ant-steps-item-wait
        > .ant-steps-item-container
        > .ant-steps-item-tail::after {
          background: var(--velotax-background-color-ghost);
      }
  }

  /**
  * ANTICON-LOADING
  */
  .anticon.anticon-loading.anticon-spin {
    width: 24px;
    height: 24px;
    svg {
      width: 24px;
      height: 24px;
    }
  }

  /**
  * ANT-MESSAGE
  */
  .ant-message {
    .ant-message-notice {
      text-align: right;
      max-width: calc(100% - 8px);
    }
  }

  /**
  * ANT-PICKER
  */
  .ant-picker {
    display: flex;
    align-items: center;
    background-color: var(--light-gray);
    border: 2px solid var(--light-gray);
    &:hover {
      border-right-width: 2px !important;
    }
    &.ant-picker-large {
      height: 48px;
      border-radius: 8px;
    }
    &.ant-picker-focused {
      border-right-width: 2px !important;
      border-color: var(--ant-primary-color);
      box-shadow: none;
    }
    &.ant-picker-disabled {
      background-color: var(--light-gray);
      .ant-picker-input input {
        opacity: 0.75;
      }
    }
    .ant-picker-input input {
      color: var(--velotax-font-color);
    }
  }
  .ant-picker-suffix {
    svg {
      fill: var(--velotax-font-color);
    }
  }
  .ant-picker-dropdown {
    .ant-picker-panel {
      border-bottom: none;
    }
    .ant-picker-panel-container {
      * {
        color: var(--velotax-font-color);
      }
      border-radius: 8px;
      background-color: var(--velotax-background-color);
      border: 2px solid var(--velotax-background-color-ghost);
      .ant-picker-header {
        border-bottom-color: var(--velotax-background-color-ghost);
      }
      .ant-picker-body {
        padding: 8px 0;
        .ant-picker-content {
          height: 240px;
          width: 100%;
          .ant-picker-cell-inner {
            height: 25px;
            line-height: 25px;
            border-radius: 6px;
            border: 1px solid var(--velotax-background-color-ghost);
          }
        }
      }
      .ant-picker-footer {
        border-top-color: var(--velotax-background-color-ghost);
      }
    }
    .ant-picker-cell:hover:not(.ant-picker-cell-selected) .ant-picker-cell-inner {
      opacity: 0.45;
      background-color: var(--light-gray) !important;
    }
  }

  body.dark .ant-picker-dropdown .ant-picker-panel-container {
    box-shadow: 0 3px 6px -4px #6666661E, 0 6px 16px 0 #66666614, 0 9px 28px 8px #6666660C;
  }

  .ant-picker-cell-disabled {
    opacity: 0.2;
  }

  .sample-payed::after,
  .sample-regular::after,
  .sample-pending::after,
  .sample-not-payed::after,
  .ant-picker-cell-inner.payed::after,
  .ant-picker-cell-inner.regular::after,
  .ant-picker-cell-inner.pending::after,
  .ant-picker-cell-inner.not-payed::after {
    content: "";
    top: -4px;
    right: -4px;
    position: absolute;
    width: 16px;
    height: 16px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--ant-primary-color);
  }
  .sample-payed::after,
  .sample-regular::after,
  .ant-picker-cell-inner.payed::after,
  .ant-picker-cell-inner.regular::after {
    background-color: var(--ant-success-color);
  }
  .sample-pending::after,
  .ant-picker-cell-inner.pending::after {
    background-color: var(--ant-error-color);
  }
  .sample-not-payed::after,
  .ant-picker-cell-inner.not-payed::after {
    background-color: var(--ant-warning-color);
  }
  .sample-payed,
  .sample-regular,
  .sample-pending,
  .sample-not-payed {
    position: relative;
    &::after {
      top: 11px;
      left: 0px;
    }
    span {
      margin-left: 24px;
    }
  }

  /**
  * ANT-UPLOAD
  */
  .ant-upload-text-icon {
    svg {
      fill: var(--ant-primary-color);
    }
  }

  .anticon.anticon-delete {
    svg {
      fill: var(--ant-error-color);
    }
  }

  .ant-upload-list-item .ant-upload-list-item-info {
    padding: 8px;
    height: 32px;
    border-radius: 8px;
  }
  .ant-upload-list-item:hover .ant-upload-list-item-info {
    background-color: var(--light-gray);
  }

  .progress {
    height: 5px;
    z-index: 1;
    background: var(--ant-primary-color);
    position: fixed;
    -webkit-transition: width 0.6s ease-in-out;
    -moz-transition: width 0.6s ease-in-out;
    -o-transition: width 0.6s ease-in-out;
    transition: width 0.6s ease-in-out;
  }

  .xmovel-content.ant-collapse-item {
    border-top: none;
    margin-bottom: 16px;
    .ant-collapse-header {
      margin-bottom: 4px;
      border-radius: 8px !important;
      color: var(--velotax-font-color);
      background-color: var(--velotax-ghost-white) !important;
    }
    .ant-collapse-content > .ant-collapse-content-box {
      padding: 0;
    }
    .ant-descriptions-view {
      table {
        tbody {
          .ant-descriptions-row {
            .ant-descriptions-item-label {
              border-color: var(--velotax-background-color-ghost) !important;
            }
            .ant-descriptions-item-content {
              border-color: var(--velotax-background-color-ghost);
              padding: 8px 16px !important;
            }
          }
        }
      }
    }
  }
  body.dark {
    .xmovel-content.ant-collapse-item {
      .ant-collapse-header {
        background-color: var(--velotax-background-color-ghost) !important;
      }
      .ant-descriptions-view {
        border-color: var(--velotax-background-color-ghost) !important;
        table {
          tbody {
            .ant-descriptions-row {
              border-color: var(--velotax-disabled) !important;
              .ant-descriptions-item-label {
                border-color: var(--velotax-background-color-ghost) !important;
                background-color: var(--velotax-background-color-ghost) !important;
              }
              .ant-descriptions-item-content {
                border-color: var(--velotax-background-color-ghost);
              }
            }
          }
        }
      }
    }
  }

  h1.app-title {
    margin: 0px;
    padding-bottom: 12px;
    font-weight: 700;
    font-size: 1.5rem;
    line-height: 2rem;
    position: relative;
    letter-spacing: -0.01em;
    color: var(--velotax-font-color);

   &::before{
    content: "";
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 80px;
    height: 2px;
    background-color: var(--veloprime-soft-gold);
   }
  }

  .add-card {
    height: 150px;
    border-radius: 8px;
    box-shadow: rgb(0 0 0 / 7%) 0px 3px 8px;
  }

  .user-menu {
    .icon-card {
      color: var(--ant-primary-color);
    }
    ul {
      margin: 0;
      display: flex;
      flex-direction: column;
      background-color: var(--white);
      box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;

      > li {
        display: flex;
        column-gap: 8px;
        cursor: pointer;
        align-items: center;
        white-space: nowrap;
        height: 56px;
        font-weight: 600;
        border-radius: 4px;
        color: var(--dark-2);
        padding: 6px 32px 6px 16px;
        transition: color var(--transition-duration-default)
          var(--transition-timing-function-default);
        transition: background-color var(--transition-duration-default)
          var(--transition-timing-function-default);

        :last-of-type {
          border-bottom: none;
        }

        :hover {
          color: var(--ant-primary-color);
          background-color: rgba(22, 52, 255, 0.06);
        }

        &.logout {
          :hover {
            color: var(--ant-error-color);
          }
        }

        svg {
          cursor: pointer;
          width: 1.25rem;
          height: 1.25rem;
          margin-right: 2px;

          :not(.stroke-color) path {
            transition: fill var(--transition-duration-default)
              var(--transition-timing-function-default);
          }

          &.stroke-color path {
            stroke-width: 1.6px;
            transition: stroke var(--transition-duration-default)
              var(--transition-timing-function-default);
          }
        }
      }
    }
  }

  .tableFilter {
    border: none !important;
    box-shadow: none !important;
    font-weight: 500 !important;
    color: #8b8b8b !important;
    transition: .3s !important;
  }
  .tableFilter:hover{
    color: var(--ant-primary-color) !important;
    transition: .3s !important;
  }
  .tableFilter svg {
    color: #8b8b8b !important;
    fill: #8b8b8b !important;
    transition: .3s !important;
  }
  .tableFilter svg:hover {
    color: var(--ant-primary-color) !important;
    fill: var(--ant-primary-color) !important;
    transition: .3s !important;
  }

  .updatePatrimonioIcon {
    color: #8b8b8b !important;
    transition: .3s !important;
  }

  .updatePatrimonioIcon:hover {
    color: var(--ant-primary-color) !important;
    transition: .3s !important;
  }

  .defaultIconSize {
    width: 18px;
    height: 18px;
  }
  .actionColumn {
    width: 70px;
  }

  .modalNotasCorretagem .ant-modal-body {
    padding-top: 1rem !important;
  }
  
  .assinaturasModal > .ant-modal-content > .ant-modal-body {
    padding-top: 0 !important;
  }
  .userPlanModal {
    width: 100%;
    max-width: 600px;
  }

  .last-update {
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    font-size: 10px;
    line-height: 1.5rem;
    color: var(--ant-primary-color);
    .button-refresh-wallet {
      width: 20px;
      height: 20px;
      padding: 4px;
      box-shadow: none;
      margin-right: 8px;
      border-radius: 4px;
      border: none !important;
      background-color: #1634ff14 !important;
      color: var(--ant-primary-color) !important;
      svg {
        width: 10px !important;
        height: 10px !important;
        min-width: 10px !important;
        min-height: 10px !important;
        * {
          stroke: var(--ant-primary-color) !important;
        }
      }
    }
    .button-refresh-wallet:hover {
      background-color: #1634ff14;
      transition: .3s;
    }
  }

  .MuiTextField-root {
    width: 100%;
  }
  .MuiInput-root {
    width: 100%;
  }

  .modalProventos {
    width: calc(100% - 128px) !important;
  }

  @media only screen and (max-device-width: 812px) {
    .modalProventos {
      width: 100% !important;
    }
  }

  .paymentModal > .ant-modal-content > .ant-modal-header {
    padding: 64px 88px 32px !important;
  }

  @media (max-width: 768px) {
    .paymentModal > .ant-modal-content > .ant-modal-header {
      padding: 64px 32px 32px !important;
    }
  }

  .recharts-default-legend {
    display: flex !important;
    flex-direction: column !important;
    transform: translateY(1.5rem) !important;
  }
  
  .recharts-layer > text {
    font-weight: 600;
    font-size: 15px;
  }

  .check {
    width: 24px;
    height: 24px;
    fill: var(--ant-primary-color);
  }
  .cross {
    width: 24px;
    height: 24px;
    fill: var(--gray-1);
  }

  .patrimonio-collapse {
    padding: 48px;
    margin-top: 2rem;
    margin-left: -48px;
    width: calc(100% + 96px);
    border-radius: 0 0 8px 8px;
    background-color: var(--white);
    & > .ant-collapse {
      border: none;
    }
    & > .ant-collapse > .ant-collapse-item.ativos-categoria {
      margin-bottom: 48px;
      &:last-of-type {
        margin-bottom: 0;
      }
      & > .ant-collapse-header {
        padding: 0;
        align-items: center;
        & > .ant-collapse-header-text {
          display: flex;
          align-items: center;
        }
        .ant-collapse-arrow {
          right: 0;
        }
        h2 {
          margin: 0 16px 0 0;
          font-weight: 700;
          font-size: 1.125rem;
          line-height: 1.5rem;
          color: var(--ant-primary-color);
        }
        .collapse-title-divider {
          flex-grow: 1;
          display: block;
          margin: 0;
          border-bottom: 1px solid var(--ghost);
          width: 20px;
          padding: 0 2rem;
        }
        .collapse-title-hidden {
          width: 32px;
          height: 24px;
          display: block;
          visibility: hidden;
        }
      }
      & > .ant-collapse-content {
        border: none;
        background-color: transparent;
        & > .ant-collapse-content-box {
          padding: 1rem 0 0 0;
          & > .ant-collapse {
            border: none;
          }
          & > div {
            font-size: 13px;
          }
        }
      }
    }

    .progress_container {
      width: 100%;
      background-color: #ffffff;
      height: 15px;
      position: relative;
      border-radius: 50px;
    }

    .loading_bar {
      height: 100%;
      background-color: var(--ant-primary-color);
      border-top-left-radius: 50px;
      border-bottom-left-radius: 50px;
      display: flex; /* Para que os elementos dentro da barra de progresso se alinhem corretamente */
      align-items: center; /* Para centralizar verticalmente o texto */
      justify-content: center; /* Para alinhar o texto à esquerda dentro da barra de progresso */
      padding-left: 10px; /* Adicione o padding necessário para dar espaço ao texto na barra */
    }

    .progress_container_text_align_center {
      /* Estilos para o texto (se necessário) */
      font-size: 11px;
      font-weight: 700;
      white-space: nowrap;
      position: absolute;
      top: -1px;
      left: 0;
      width: 100%;
      color: white;
    }
  }

  @media only screen and (max-device-width: 812px) {
    .patrimonio-collapse {
      padding: 24px;
      margin-top: 2rem;
      border-radius: 0;
      margin-left: -24px;
      width: calc(100% + 48px);
      & > .ant-collapse > .ant-collapse-item.ativos-categoria {
        margin-bottom: 48px;
        & > .ant-collapse-header {
          & > .ant-collapse-header-text {
            display: flex;
            align-items: center;
            h2 {
              font-size: 1rem;
              line-height: 1.25rem;
              letter-spacing: -1px;
            }
          }
        }
      }
      .progress_container_text_align_center {
        top: -2px;
      }
    }
  }

  .patrimonioMessages {
    margin-top: 16px;
    font-weight: 400;
    padding-top: 16px;
    line-height: 1rem;
    font-size: 0.75rem;
    color: var(--gray-2);
    border-top: 1px solid var(--ghost);
    li {
      padding-left: 16px;
      margin-bottom: 6px;
      position: relative;
      .anticon-info-circle {
        left: 0;
        top: 1px;
        position: absolute;
        color: var(--ant-primary-color);
      }
    }
  }

  @media only screen and (max-device-width: 812px) {
    iframe[title^="Botão para abrir a janela"] {
      display: none;
    }
  }

  .operationsModal .ant-modal-header, .operationsModal .ant-modal-body {
    @media only screen and (max-device-width: 670px) {
      padding: 2rem 1rem 1rem 1rem !important;
    }
  }

  .operationsCollapse{
    .ant-collapse-header{
      padding: 2rem 0 1rem 0 !important;
    }
    .ant-collapse-content {
      padding: 0 !important;
    }
    .ant-collapse-content-box {
      padding: 0 !important;
    }
  }

  .corretoras-allcheck > .ant-checkbox > .ant-checkbox-inner::after {
    width: 8px;
    height: 8px;
    top: 50%;
  }

  .corretoras-allcheck > .ant-checkbox-checked > .ant-checkbox-inner::after {
    width: 7px;
    height: 13px;
    top: calc(50% - 2px);
  }
  
  // Estilos responsivos para paginação apenas em mobile
  @media only screen and (max-device-width: 812px) {
    .ant-table-pagination {
      display: flex !important;
      visibility: visible !important;
      opacity: 1 !important;
      position: relative !important;
      bottom: auto !important;
      margin: 16px 0 0 0 !important;
      background-color: white !important;
      border-top: 1px solid #e8e8e8;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      z-index: 1000 !important;
      
      // Garantir que todos os elementos da paginação sejam visíveis
      .ant-pagination-item,
      .ant-pagination-item-link,
      .ant-pagination-prev,
      .ant-pagination-next {
        display: inline-block !important;
        visibility: visible !important;
        opacity: 1 !important;
      }
      
      .ant-pagination-item a {
        display: block !important;
        visibility: visible !important;
      }
      
      // Ocultar opções desnecessárias em mobile
      .ant-pagination-options {
        display: none !important;
      }
    }
  }
`;
